function notify(message, onClick) {
    if ('Notification' in window && Notification.permission === 'granted') {
        const notification = new Notification(message);
        if (onClick) notification.onclick = onClick;
        return notification;
    }
    return null;
}

function requestNotificationPermission() {
    if ('Notification' in window && Notification.permission !== 'granted' && Notification.permission !== 'denied') {
        Notification.requestPermission();
    }
}

export default notify;
export { requestNotificationPermission };
